// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__+agX2","header":"Popover_header__gRKKc","title":"Popover_title__tx2xP","closeButton":"Popover_closeButton__EmCsH","content":"Popover_content__l39UY"};